<template>
    <v-item-group>
        <v-container>
            <v-row >
                <v-col
                        v-for="(tab, index) in tabData"
                        :key="index"
                        cols="12"
                        lg="3"
                        md="6"
                >
                    <v-item >
                        <v-card
                                class="d-flex pa-lg-4 pa-3"
                                min-height="270"
                                @click="handleClick(tab.link, tab.title )"
                        >
                            <v-scroll-y-transition>
                                <div class="flex-grow-1 text-center flex-column d-flex"
                                >
                                    <h3 class="py-4">{{tab.title}}</h3>
                                    <v-icon class="py-2" color="primary" x-large>{{ tab.icon }}</v-icon>
                                    <span class="py-2">{{tab.content}}</span>
                                </div>
                            </v-scroll-y-transition>
                        </v-card>
                    </v-item>
                </v-col>
                <v-btn
                        v-if="showVNCTab"
                        :width="width"
                        outlined
                        depressed
                        :to="vncViewer.link"
                >
                    {{ vncViewer.content }}
                </v-btn>
            </v-row>
        </v-container>
    </v-item-group>
</template>

<script>
    import {REALTIME_SCAN_LANDING, VNC_VIEWER} from "../../utils/routes";
    import { createNamespacedHelpers } from "vuex";
    const authHelper = createNamespacedHelpers("auth");
    import {
        REJECT_ENTER_MSG,
    } from "../../utils/constants";
    export default {
        name: "Tab",
        props: {
            showVNCTab: {
                type: Boolean,
                default: false
            },
            hasVNC: {
                type: Boolean,
                default: true
            },
            tabData: {
                type: Array,
                required: true
            },
            width: {
                type: String
            }
        },
        computed: {
            ...authHelper.mapGetters(["isAdmin"]),
        },
        data: () => ({
            vncViewer: {
                link: `${REALTIME_SCAN_LANDING.path}/${VNC_VIEWER.path}`,
                content: "VNC VIEWER"
            }
        }),
        methods: {
            handleClick(link, tabName){
                if (tabName === 'AUDIT SCREENSHOTS' && !this.isAdmin ){
                    return window.alert(`${REJECT_ENTER_MSG}`);
                    // this.$router.push(`${REALTIME_SCAN_LANDING.path}${REALTIME_SCAN.path}`);
                    //why this redirect? uncomment if it needs
                } else {
                    this.$router.push(link)
                }
            }
        }
    };
</script>
